// export default AboutSettings;
import { useState, useEffect, useRef } from "react";
import { Form, message } from "antd";
import { debounce } from "lodash";
import Header from "../../components/Includes/Header";
import { useFetch } from "../../Services/useFetch";
import { DocImgBaseUrl } from "../../utils/configurable";

const AboutSettings = () => {
  const [logoFile, setLogoFile] = useState();
  const [faviconFile, setFaviconFile] = useState(null);
  const [value, setValue] = useState(null);
  const { request } = useFetch();

  const logoRef = useRef(null);
  const faviconRef = useRef(null);

  const handlelogoClick = () => {
    logoRef.current.click();
  };

  const handlefaviconClick = () => {
    faviconRef.current.click();
  };

  const fetchSeoData = debounce(async () => {
    try {
      const response = await request("/seo-data-get", "get", null, {
        "Content-Type": "application/x-www-form-urlencoded",
      });

      if (response?.data?.status === "1") {
        const data = response?.data?.data;
        setValue(data?.title?.title || "");
        setLogoFile([
          {
            uid: "-1",
            name: "logo",
            status: "done",
            url: `${DocImgBaseUrl}${data?.logo?.path}${data?.logo?.logo}`,
          },
        ]);
        setFaviconFile([
          {
            uid: "-2",
            name: "favicon",
            status: "done",
            url: `${DocImgBaseUrl}${data?.favicon?.path}${data?.favicon?.favicon}`,
          },
        ]);
      }
    } catch (error) {
      message.error("Failed to fetch SEO data.");
    }
  }, 300);

  const handleBeforeUpload = async (file, type) => {
    const formData = new FormData();
    const field = type === "logo" ? "logo_file" : "icon_file";
    formData.append(field, file);

    try {
      const response =
        type === "logo"
          ? await request("/seo-logo-set", "post", formData, { "Content-Type": "application/x-www-form-urlencoded" })
          : await request("/seo-favicon-set", "post", formData, {
              "Content-Type": "application/x-www-form-urlencoded",
            });

      if (response?.data?.status === "1") {
        await fetchSeoData();
        message.success(`${type === "logo" ? "Logo" : "Favicon"} saved successfully!`);
      }
    } catch (error) {
      message.error(`Failed to upload ${type}: ${error?.message}`);
    }

    return false;
  };

  useEffect(() => {
    fetchSeoData();
  }, []);
  console.log(logoFile);
  return (
    <>
      <Header />

      <div style={{ height: "100vh", marginTop: "60px" }}>
        <Form className="setting-class" style={{ width: "50%", margin: "auto", display: "grid", gap: "20px" }}>
          <div>
            <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>Logo</h2>
            <br />
            <p>Your main brand logo that will appear across your application</p>
            <div
              onClick={handlelogoClick}
              style={{
                padding: "20px",
                border: "2px dashed #e2e8f0",
                borderRadius: "8px",
                background: "linear-gradient(135deg, #f9f9f9, #ffffff)",
              }}
            >
              <div className="upload_File">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-upload"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                </svg>
                <span style={{ fontWeight: "500" }}>Choose file to upload</span>
                <p>PNG, JPG, JPEG, SVG up to 10MB</p>
              </div>
            </div>

            <Form.Item label="Logo" name="logo" style={{ display: "none" }}>
              <input
                ref={logoRef}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleBeforeUpload(e.target.files[0], "logo")}
              />
            </Form.Item>

            {logoFile && (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "6px",
                  border: "1px solid #e2e8f0",
                  marginTop: "8px",
                  padding: "10px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <img
                  src={logoFile[0].url}
                  alt="logo"
                  style={{ width: "40px", aspectRatio: "1/1", borderRadius: "4px" }}
                />
                <span>{logoFile[0].name}</span>
              </div>
            )}
          </div>

          <div>
            <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>Favicon</h2>
            <br />
            <p>Small icon that appears in browser tabs and bookmarks</p>
            <div
              onClick={handlefaviconClick}
              style={{
                padding: "20px",
                border: "2px dashed #e2e8f0",
                borderRadius: "8px",
                background: "linear-gradient(135deg, #f9f9f9, #ffffff)",
              }}
            >
              <div className="upload_File">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-upload"
                  viewBox="0 0 16 16"
                >
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                </svg>
                <span style={{ fontWeight: "500" }}>Choose file to upload</span>
                <p>PNG, ICO, SVG up to 2MB</p>
              </div>
            </div>
            <Form.Item label="Favicon" name="favicon" style={{ display: "none" }}>
              <input
                ref={faviconRef}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleBeforeUpload(e.target.files[0], "favicon")}
              />
            </Form.Item>
            {faviconFile && (
              <div
                style={{
                  background: "#fff",
                  borderRadius: "6px",
                  border: "1px solid #e2e8f0",
                  marginTop: "8px",
                  padding: "10px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                }}
              >
                <img
                  src={faviconFile[0].url}
                  alt="logo"
                  style={{ width: "40px", aspectRatio: "1/1", borderRadius: "4px" }}
                />
                <span>{faviconFile[0].name}</span>
              </div>
            )}
          </div>
        </Form>
      </div>
    </>
  );
};

export default AboutSettings;
